import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { Checkbox } from 'informed';
import PropTypes from 'prop-types';

import { FAIcon } from 'lib/customPropTypes';

import { Icon } from '../Icons';

import './styles/checkAndRadioStyles.css';

const CustomCheckbox = ({ children, className, field, icon, ...rest }) => {
  return (
    <label className={`custom-checkbox ${className}`} htmlFor={field}>
      <Checkbox className="checkbox" field={field} id={field} {...rest} />
      <Icon icon={icon} />
      <span>{children}</span>
    </label>
  );
};

CustomCheckbox.defaultProps = {
  className: '',
  icon: faCheck,
};

CustomCheckbox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  icon: FAIcon,
};

export default CustomCheckbox;
